import type { CreateNewsfeedEventInput } from "~graphql/generated/graphql"
import { useCreateNewsfeedPostInteractedWithEventMutation } from "~graphql/generated/graphql"

export default function useCreatePostInteractedWithEvent() {
    const [
        createPostInteractedWithEventMutation,
        { loading: isLoading, error },
    ] = useCreateNewsfeedPostInteractedWithEventMutation()

    const createPostInteractedWithEvent = (data: CreateNewsfeedEventInput) =>
        createPostInteractedWithEventMutation({ variables: { data } })

    return { createPostInteractedWithEvent, isLoading, error }
}
